import { Component, Input } from '@angular/core';

import { ApiCallCachingService } from '../../services/api-call-caching.service';
import { ApplicationSettings } from 'lib-config';

import { DropdownBaseComponent } from './dropdown-base/dropdown-base.component';

import { UserService } from '../../services/user.service';

import { UserListItem } from '../../models/users/user-list-item.model';

import { map } from 'rxjs/operators';

@Component({
    selector: 'spv2-simple-users-dropdown',
    templateUrl: './dropdown-base/dropdown-base.component.html',
    styleUrls: ['./dropdown-base/dropdown-base.component.scss'],
    standalone: false
})
export class SimpleUsersDropdownComponent extends DropdownBaseComponent<string, UserListItem> {
  
  private _searchString : string;
  @Input() public set searchString(v : string) {
    this._searchString = v;
    if(this.value) {
      this.value = null;
      this.valueChange.emit(this.value);
    }
    this.debounceTrigger.execute(null);
  }

  get uniqueName() {
    return "user" + this._searchString;
  } 

  enableCache = false;
  loadDataAutomatically = false;

  textField = "fullName";
  valueField = "fullName";

  dataFunction = (filter: string) => {
    if(filter?.length > 2 || this.value) return this.userService.getUserList(this.settings.policyServiceAppId, !this.disabled, filter);
  };

  constructor(private userService: UserService, cachingService: ApiCallCachingService, private settings: ApplicationSettings) {
    super(cachingService);
  }

}